import "./Team.css";
import Img2 from '../assets/peter.jpg';
import { useTranslation } from "react-i18next";
import EditorialButton from './Button';


const Team = () => {
  const { t } = useTranslation();

  return (
    <section id="team" className="mag-team-clean">
      <div className="mag-team-container">

        <div className="mag-team-grid">
          <div className="mag-team-visual">
            <img src={Img2} alt="Peter Olvsborn" className="mag-team-img" />
          </div>

          <div className="mag-team-content">
            <span className="mag-team-label">{t("teamMemberLabel") || "FOUNDER"}</span>

            <div className="mag-team-header">
              <h2 className="mag-team-name">Peter Olvsborn</h2>
              <p className="mag-team-title">{t("teamMemberTitle")}</p>
            </div>



            <div className="mag-team-contact">
              <a href={`tel:${t("teamMemberPhone")}`} className="mag-contact-link">
                {t("teamMemberPhone")}
              </a>
              <a href="mailto:peter@dinmaklareahus.se" className="mag-contact-link">
                peter@dinmaklareahus.se
              </a>
            </div>

            <EditorialButton
                label={t("teamReadMore")}
                to="/peter"
              />
          </div>

        </div>
      </div>
    </section>
  );
};

export default Team;